<section class="page-hero">
    <div class="container">
        <span class="eyebrow"><i></i> Admin Home Page</span>
        <h1>Manage home page content.</h1>
        <p>Hero, metrics, trust items, industries, badges, cases, process and features.</p>
    </div>
</section>

<section class="section">
    <div class="container">

        <div style="margin-bottom:24px">
            <a class="learn" routerLink="/admin/dashboard">← Back to dashboard</a>
        </div>

        <div *ngIf="loading">Loading home data...</div>

        <div *ngIf="successMessage" class="alert success" style="margin-bottom:16px">
            {{ successMessage }}
        </div>

        <div *ngIf="errorMessage" class="alert error" style="margin-bottom:16px">
            {{ errorMessage }}
        </div>

        <div class="quote-panel" style="margin-bottom:28px">
            <span class="section-kicker">Home Hero</span>
            <h2 style="font-size:32px;margin-top:8px">Hero section</h2>

            <div class="form-grid">
                <div class="field full">
                    <label>Eyebrow</label>
                    <input [(ngModel)]="hero.eyebrow" name="heroEyebrow">
                </div>

                <div class="field full">
                    <label>Title</label>
                    <input [(ngModel)]="hero.title" name="heroTitle">
                </div>

                <div class="field full">
                    <label>Description</label>
                    <textarea [(ngModel)]="hero.description" name="heroDescription"></textarea>
                </div>

                <div class="field">
                    <label>Primary Button Text</label>
                    <input [(ngModel)]="hero.primaryText" name="primaryText">
                </div>

                <div class="field">
                    <label>Primary Button URL</label>
                    <input [(ngModel)]="hero.primaryUrl" name="primaryUrl" placeholder="/contact">
                </div>

                <div class="field">
                    <label>Secondary Button Text</label>
                    <input [(ngModel)]="hero.secondaryText" name="secondaryText">
                </div>

                <div class="field">
                    <label>Secondary Button URL</label>
                    <input [(ngModel)]="hero.secondaryUrl" name="secondaryUrl" placeholder="/services">
                </div>

                <div class="field">
                    <label>Status</label>
                    <select [(ngModel)]="hero.status" name="heroStatus">
                        <option [ngValue]="true">Active</option>
                        <option [ngValue]="false">Hidden</option>
                    </select>
                </div>

                <div class="field full">
                    <button class="btn btn-primary" type="button" (click)="saveHero()" [disabled]="saving">
                        {{ saving ? 'Saving...' : 'Save Hero' }}
                    </button>
                </div>
            </div>
        </div>

        <div class="contact-grid">
            <main class="quote-panel">
                <span class="section-kicker">Home Items</span>
                <h2 style="font-size:32px;margin-top:8px">
                    {{ itemModel.id === 0 ? 'New Item' : 'Edit Item' }}
                </h2>

                <div class="cert-filter-bar" style="margin:16px 0">
                    <button type="button"
                            *ngFor="let t of typeList"
                            [class.active]="selectedType === t.key"
                            (click)="changeType(t.key)">
                        {{ t.name }}
                    </button>
                </div>

                <div class="form-grid">

                    <ng-container *ngIf="isMetrics()">
                        <div class="field">
                            <label>Value</label>
                            <input [(ngModel)]="itemModel.value" name="metricValue" placeholder="20+">
                        </div>

                        <div class="field">
                            <label>Label</label>
                            <input [(ngModel)]="itemModel.label" name="metricLabel" placeholder="Years in supply">
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isNumbered()">
                        <div class="field">
                            <label>No</label>
                            <input [(ngModel)]="itemModel.no" name="itemNo" placeholder="01">
                        </div>

                        <div class="field">
                            <label>Title</label>
                            <input [(ngModel)]="itemModel.title" name="numberedTitle">
                        </div>
                    </ng-container>

                    <ng-container *ngIf="isCase()">
                        <div class="field">
                            <label>Tag</label>
                            <input [(ngModel)]="itemModel.tag" name="caseTag" placeholder="Supply">
                        </div>

                        <div class="field">
                            <label>Title</label>
                            <input [(ngModel)]="itemModel.title" name="caseTitle">
                        </div>
                    </ng-container>

                    <ng-container *ngIf="!isMetrics() && !isNumbered() && !isCase()">
                        <div class="field full">
                            <label>Title</label>
                            <input [(ngModel)]="itemModel.title" name="simpleTitle">
                        </div>
                    </ng-container>

                    <div class="field full" *ngIf="!isMetrics()">
                        <label>Description</label>
                        <textarea [(ngModel)]="itemModel.description" name="itemDescription"></textarea>
                    </div>

                    <div class="field">
                        <label>Sort</label>
                        <input type="number" [(ngModel)]="itemModel.sort" name="itemSort">
                    </div>

                    <div class="field">
                        <label>Status</label>
                        <select [(ngModel)]="itemModel.status" name="itemStatus">
                            <option [ngValue]="true">Active</option>
                            <option [ngValue]="false">Hidden</option>
                        </select>
                    </div>

                    <div class="field full" style="display:flex;gap:10px;flex-direction:row">
                        <button class="btn btn-primary" type="button" (click)="saveItem()" [disabled]="saving">
                            {{ saving ? 'Saving...' : 'Save Item' }}
                        </button>

                        <button class="btn btn-ghost" type="button" (click)="newItem()">
                            Clear
                        </button>
                    </div>
                </div>
            </main>

            <aside>
                <span class="section-kicker">Current Items</span>
                <h2 style="font-size:34px">{{ selectedType }}</h2>

                <div class="office-card premium-office" *ngFor="let item of getItems()">
                    <h3>
                        {{ item.title || item.value || item.no || item.tag }}
                    </h3>

                    <p>
                        {{ item.description || item.label || item.tag || '-' }}
                    </p>

                    <span>{{ item.status ? 'Active' : 'Hidden' }} / Sort {{ item.sort }}</span>

                    <div style="display:flex;gap:8px;margin-top:14px">
                        <button class="btn btn-ghost" type="button" (click)="editItem(item)">
                            Edit
                        </button>

                        <button class="btn btn-dark" type="button" (click)="deleteItem(item)">
                            Delete
                        </button>
                    </div>
                </div>

                <div *ngIf="getItems().length === 0" style="padding:20px 0">
                    No items found.
                </div>
            </aside>
        </div>

    </div>
</section>